
import styled from "styled-components";

const StyledDetailsButton = styled.button`
    padding: 1rem 2rem;
    color: #313131;
    background: #fff;
    border: 2px solid #000;
    margin-right: 2rem;
    font-weight: 600;
    cursor: pointer;
`;

export default StyledDetailsButton;
